import { render, staticRenderFns } from "./PractitionerEpisodesGrid.vue?vue&type=template&id=dd80e946&scoped=true&"
import script from "./PractitionerEpisodesGrid.vue?vue&type=script&lang=js&"
export * from "./PractitionerEpisodesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd80e946",
  null
  
)

export default component.exports